import {
   PatientConsentDocumentTemplateContent,
   PatientConsentDocumentTemplateQuery,
} from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

type ConsentsAndAuthorizationsDocumentTemplateLoaderRenderProps = {
   patientConsentDocumentTemplate: PatientConsentDocumentTemplateContent;
};

type ConsentsAndAuthorizationsDocumentTemplateLoaderProps = {
   readonly patientId: number;
   readonly printTemplateId: number;
   readonly children: (renderProps: ConsentsAndAuthorizationsDocumentTemplateLoaderRenderProps) => JSX.Element;
};

export const ConsentsAndAuthorizationsDocumentTemplateLoader = (
   props: ConsentsAndAuthorizationsDocumentTemplateLoaderProps
): JSX.Element => {
   const {
      data: patientConsentDocumentTemplate,
      loading: patientConsentDocumentTemplateLoading,
      error: patientConsentDocumentTemplateError,
   } = useCqrsGet<PatientConsentDocumentTemplateContent>(() => {
      const query = new PatientConsentDocumentTemplateQuery();
      query.printTemplateId = props.printTemplateId;
      query.patientId = props.patientId;
      return query;
   });

   if (patientConsentDocumentTemplateLoading) {
      return <LoaderSpinner />;
   }

   if (patientConsentDocumentTemplateError) {
      return (
         <Message
            testId={'consentsAndAuthorizationsDocumentTemplate'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      patientConsentDocumentTemplate: patientConsentDocumentTemplate,
   });
};
